import { render, staticRenderFns } from "./UserButtons.vue?vue&type=template&id=5480f5c2&lang=html&"
import script from "./UserButtons.vue?vue&type=script&lang=js&"
export * from "./UserButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports